var $ = jQuery.noConflict ();

jQuery (document).ready (function (){

    var initializeBlock = function ($block){

        const catNav = $('.cat-list_item');
        let active = $('.cat-list_item.active').data('slug');
        const perPage = 3;

        catNav.on ('click', function (e){
            e.preventDefault();
            active = $(e.target).data("slug");
            catNav.removeClass('active');
            $(e.target).addClass('active');

            checkCategory();
        });

        const post = $('.col-post');

        function checkCategory(){
            if (active.length <=0){
                //console.log('all');
                post.addClass('active');
                post.addClass('visible');

            } else {
                //console.log(active);
                post.removeClass('active');
                post.removeClass('visible');

                for (var a=0; a<post.length; a++){
                    const index = a;
                    const categories = $('.categories .btn-mini',post.eq(a));
                    for (var b=0; b<categories.length; b++){
                        if (categories.eq(b).data('slug').toString() === active.toString()){
                            post.eq(index).addClass('active');
                            break;
                        }
                    }
                }
            }

            checkPages();
        }

        let total;
        let pages;

        const buttons = $('.pagination__pages');

        function checkPages(){
            total = $('.col-post.active').length;
            pages = Math.ceil(total/perPage);

            buttons.empty();
            for (var a=0; a<pages; a++){
                buttons.append('<a class="btn-page">' + parseInt(a+1) + '</a>');
            }

            showPosts(1);
            $('.pagination__pages .btn-page', $(document)).eq(0).click();

            if (parseInt(pages) > 1){
                $('.pagination-wrapper').addClass('active');
            } else {
                $('.pagination-wrapper').removeClass('active');
            }
        }

        checkCategory();

        function showPosts(index){
            const postActive = $('.col-post.active');

            post.removeClass('visible');
            postActive.each(function(n) {
                if (n >= perPage * (index - 1) && n < perPage * index)
                    $(this).addClass('visible');
            });
        }

        $(document).on('click','.pagination__pages .btn-page',function(e){
            const current = $(e.target);
            const index = parseInt(current.index() + 1);

            $('.pagination__pages .btn-page').removeClass('active');
            current.addClass('active');

            showPosts(index);
        });
        $('.pagination__pages .btn-page', $(document)).eq(0).click();

        const prev = $('.btn-pagination--prev');
        const next = $('.btn-pagination--next');

        prev.on ('click', function (e){
            e.preventDefault();
            const id = $('.btn-page.active').index();
            if (id > 0 ){
                $('.pagination__pages .btn-page', $(document)).eq(id-1).click();
            }
        });

        next.on ('click', function (e){
            e.preventDefault();
            const id = $('.btn-page.active').index();
            if (id < ($('.pagination__pages .btn-page', $(document)).length - 1) ){
                $('.pagination__pages .btn-page', $(document)).eq(id+1).click();
            }
        });
    };

    window.onload = function (){
        initializeBlock ($ (this));
    } ();


    if (window.acf) {
        window.acf.addAction ('render_block_preview/type=posts-listing', initializeBlock);
    }

});